import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import {
  FETCH_DEALER_ENTITLEMENTS,
  GET_DEALER_ENTITLEMENT,
  FETCH_DEALER_CREDIT_TRANSACTIONS,
  FETCH_DEALERS,
  GET_DEALER,
  UPDATE_DEALER,
  FETCH_DEALER_BRANCHES,
  SET_ENTITLEMENT_VERIFIED_MAC,
  SYNC_ENTITLEMENT,
} from 'actions/dealerEntitlement';

function* fetchDealerEntitlements(action) {
  try {
    const response = yield call(API.getDealerEntitlements, action.payload);
    yield put({ type: FETCH_DEALER_ENTITLEMENTS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_DEALER_ENTITLEMENTS.FAIL, payload: { error: e } });
  }
}

function* getDealerEntitlement(action) {
  try {
    const response = yield call(API.getDealerEntitlementById, action.payload);
    yield put({ type: GET_DEALER_ENTITLEMENT.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_DEALER_ENTITLEMENT.FAIL, payload: { error: e } });
  }
}

function* fetchDealerCreditTransactions(action) {
  try {
    const response = yield call(API.getDealerCreditTransactions, action.payload);
    yield put({ type: FETCH_DEALER_CREDIT_TRANSACTIONS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_DEALER_CREDIT_TRANSACTIONS.FAIL, payload: { error: e } });
  }
}

function* fetchDealers(action) {
  try {
    const response = yield call(API.getDealers, action.payload);
    yield put({ type: FETCH_DEALERS.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_DEALERS.FAIL, payload: { error: e } });
  }
}

function* getDealer(action) {
  try {
    const response = yield call(API.getDealerById, action.payload);
    yield put({ type: GET_DEALER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_DEALER.FAIL, payload: { error: e } });
  }
}

function* fetchDealerBranches(action) {
  try {
    const response = yield call(API.getDealerBranches, action.payload);
    yield put({ type: FETCH_DEALER_BRANCHES.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_DEALER_BRANCHES.FAIL, payload: { error: e } });
  }
}

function* updateDealer(action) {
  try {
    const response = yield call(API.updateDealer, action.payload);
    yield put({ type: UPDATE_DEALER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_DEALER.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* setEntitlementVerifiedMac(action) {
  try {
    const response = yield call(API.setEntitlementVerifiedMac, action.payload);
    yield put({ type: SET_ENTITLEMENT_VERIFIED_MAC.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: SET_ENTITLEMENT_VERIFIED_MAC.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* syncEntitlement(action) {
  try {
    const response = yield call(API.syncEntitlement, action.payload);
    yield put({ type: SYNC_ENTITLEMENT.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: SYNC_ENTITLEMENT.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* dealerEntitlement() {
  yield takeLatest(FETCH_DEALER_ENTITLEMENTS.REQUEST, fetchDealerEntitlements);
  yield takeLatest(GET_DEALER_ENTITLEMENT.REQUEST, getDealerEntitlement);
  yield takeLatest(FETCH_DEALER_CREDIT_TRANSACTIONS.REQUEST, fetchDealerCreditTransactions);
  yield takeLatest(FETCH_DEALERS.REQUEST, fetchDealers);
  yield takeLatest(GET_DEALER.REQUEST, getDealer);
  yield takeLatest(UPDATE_DEALER.REQUEST, updateDealer);
  yield takeLatest(FETCH_DEALER_BRANCHES.REQUEST, fetchDealerBranches);
  yield takeLatest(SET_ENTITLEMENT_VERIFIED_MAC.REQUEST, setEntitlementVerifiedMac);
  yield takeLatest(SYNC_ENTITLEMENT.REQUEST, syncEntitlement);
}

export default dealerEntitlement;
